import type { ProjectItem } from '@store/reducers/dashboard/types'

export const canSetProjectStatus = (project: ProjectItem) =>
  project.type === 'sitemap' &&
  !project.template &&
  !project.archived &&
  project.features.includes('status')
